export default __webpack_public_path__ + "static/media/WhatsApp Image 2021-04-07 at 11.31.35 PM.5a1a63a8.jpeg";